import { Component, Prop, Vue } from 'vue-property-decorator'
import { assign, chain, map } from 'lodash'
import { Circuit, CircuitExercise, Routine, RoutineCircuit } from '@/interfaces'

@Component
export default class RoutineMixin extends Vue {
  @Prop({ default: '' }) routineId!: string

  weightOffset: number = 0
  weightOffsetIncrement: number = 2.5

  get routine (): Routine {
    return this.$store.state.routines.base[this.routineId]
  }

  get routineCircuits (): Circuit[] {
    return map(this.routine.circuits, (routineCircuit: RoutineCircuit) => {
      const circuit = assign(
        this.$store.state.circuits.base[routineCircuit.circuitId],
        routineCircuit
      )

      circuit.exercises = map(circuit.exercises, (circuitExercise: CircuitExercise) => {
        return assign(
          {},
          this.$store.state.exercises.base[circuitExercise.exerciseId],
          circuitExercise
        )
      })

      return circuit
    })
  }

  get routineExercises (): CircuitExercise[] {
    const exercises: CircuitExercise[] = chain(this.routineCircuits)
      .map('exercises')
      .flatten()
      .value()

    return map(exercises, (circuitExercise: CircuitExercise) => {
      return assign(
        this.$store.state.exercises.base[circuitExercise.exerciseId],
        circuitExercise
      )
    })
  }

  decreaseWeight () {
    this.weightOffset -= this.weightOffsetIncrement
  }

  increaseWeight () {
    this.weightOffset += this.weightOffsetIncrement
  }
}
